// extracted by mini-css-extract-plugin
export var checkbox = "_6y-0";
export var circle = "_6y-3";
export var horizontalContainer = "_6y-7";
export var sm = "_6y-5";
export var switch0 = "_6y-2";
export var switchDisabled = "_6y-8";
export var switchEnabled = "_6y-1";
export var textSwitchContainer = "_6y-9";
export var textSwitchOption = "_6y-a";
export var textSwitchOptionSelected = "_6y-b";
export var verticalContainer = "_6y-6";
export var xs = "_6y-4";